<div
  role="group"
  class="example-tel-input-container"
  [formGroup]="parts"
  [attr.aria-labelledby]="_formField?.getLabelId()"
>
  <div style="display: flex; flex-direction: row">
    <div style="width: 100%">
      <mat-chip-list #chipList>
        <mat-chip
          *ngFor="let option of selectedOptions$ | async"
          [selectable]="true"
          [removable]="true"
          (removed)="remove(option)"
        >
          {{ option.getName() }}
          <mat-icon  *ngIf="!disabled" matChipRemove>cancel</mat-icon>
        </mat-chip>
        <input *ngIf="!disabled"
          placeholder="{{ schema.placeholder }}"
          #chipInput
          [formControl]="inputFormControl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
          (focus)="onFocusIn($event)"
          (blur)="onFocusOut($event)"
        />
      </mat-chip-list>
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="selected($event)"
      >
        <mat-option
          *ngFor="let option of filteredOptions$ | async"
          [value]="option.getName()"
        >
          {{ option.getName() }}
        </mat-option>
      </mat-autocomplete>
    </div>
    <div style="padding-left: 10px;">
      <mat-checkbox #except class="example-margin" [checked]="value?.except" (change)="exceptChanged($event.checked)"
        >Exceto</mat-checkbox
      >
    </div>
  </div>
  <div>
    <mat-progress-bar mode="indeterminate" [class.show]="loading$ | async" [class.hide]="!(loading$ | async)"></mat-progress-bar>
  </div>
</div>
